import { render, staticRenderFns } from "./PracticeItemOption.vue?vue&type=template&id=ff3617ae&scoped=true&"
import script from "./PracticeItemOption.vue?vue&type=script&lang=js&"
export * from "./PracticeItemOption.vue?vue&type=script&lang=js&"
import style0 from "./PracticeItemOption.vue?vue&type=style&index=0&id=ff3617ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3617ae",
  null
  
)

export default component.exports